import { render } from "./operaciones-contactos.vue?vue&type=template&id=50e88657"
import script from "./operaciones-contactos.vue?vue&type=script&lang=js"
export * from "./operaciones-contactos.vue?vue&type=script&lang=js"

import "./operaciones-contactos.vue?vue&type=style&index=0&id=50e88657&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__